/* eslint-disable react/no-unknown-property */
import React from 'react';

import { Box, Grid, Stack, Typography } from '@mui/material';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';
import { AssetIcon } from 'src/v2/components/ui/icons/assets';

import { primaryColors } from '~components/theme/styles/colors';
import { secondaryBox } from '~components/theme/styles/mixins';
import { ENativeAsset, EOtherAsset } from '~config/types';

import SlideWrapper from '../SlideWrapper';

function StakingSlide() {
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Box textAlign={{ xs: 'center', sm: 'left' }}>
        <Typography variant={'h4'}>
          Participate in our staking programmes and start earning substantial returns from day one
        </Typography>
        <Typography variant={'body1'} color={primaryColors[400]} my={4}>
          An in-house innovation to put your VST at work and further protect the protocol by acting as a
          secondary security buffer to backstop liquidation, similarly to stability pools.
        </Typography>
      </Box>
      <Grid container direction={{ xs: 'column', sm: 'row' }} spacing={4}>
        <Grid item xs={6}>
          <Box sx={secondaryBox}>
            <Stack direction={'row'} alignItems={'center'} spacing={4}>
              <AssetIcon size={42} asset={ENativeAsset.VSTA} noBg noBorder />
              <Typography variant={'h5'}>Saving Module</Typography>
            </Stack>

            <Typography variant={'body1'} my={4} color={primaryColors[400]}>
              Deposit VST into Vesta Saving Module to earn 10% yield on stablecoin
            </Typography>
            <ButtonWithIcon iconType="asterisk">VESTA SAVING MODULE</ButtonWithIcon>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Box sx={secondaryBox}>
            <Stack direction={'row'} alignItems={'center'} spacing={4}>
              <AssetIcon size={42} asset={EOtherAsset.FRAX} noBg noBorder />
              <Typography variant={'h5'}>Frax Gauge</Typography>
            </Stack>

            <Typography variant={'body1'} my={4} color={primaryColors[400]}>
              Provide liquidity into the VST-FRAX pool to earn 20% APR in FXS.
            </Typography>
            <ButtonWithIcon iconType="asterisk">LIQUIDITY STAKING</ButtonWithIcon>
          </Box>
        </Grid>
      </Grid>
    </SlideWrapper>
  );
}

export default StakingSlide;
